import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { completeResetPassword } from '@/services/forgot-password.service';
import type {
  CompleteResetPasswordRequest,
  CompleteResetPasswordResponse,
} from '@/services/forgot-password.types';

export type ResetPasswordFormValues = { newPassword: string };

type Options = Pick<
  UseMutationOptions<
    CompleteResetPasswordResponse,
    unknown,
    CompleteResetPasswordRequest
  >,
  'onSuccess' | 'onError'
>;

const useResetPasswordMutation = (options: Options = {}) =>
  useMutation<
    CompleteResetPasswordResponse,
    unknown,
    CompleteResetPasswordRequest
  >({
    mutationFn: (body) => completeResetPassword(body),
    ...options,
  });

export default useResetPasswordMutation;
